var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[(!_vm.loading)?_c('router-view'):_c('Spinner',{staticClass:"app__spinner",attrs:{"width":50}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }